export default function buildMakeFlowDevice({ validate, validators, makeFlowDeviceKFactor }) {
  return function makeFlowDevice({
    id,
    companyId,
    name,
    diameter,
    defaultDevice = false,
    flowDeviceKFactors = [],
    createdBy,
    createdDate = new Date(),
    modifiedBy,
    modifiedDate = new Date(),
    deletedBy,
    deletedDate,
  }) {
    const schema = {
      id: {
        prettyName: 'ID',
        validators: [validators.isString(), validators.exactLength(36)],
      },
      companyId: {
        prettyName: 'Company ID',
        validators: [validators.isString(), validators.exactLength(36)],
      },
      name: {
        prettyName: 'Name',
        validators: [validators.isString(), validators.notEmpty()],
      },
      diameter: {
        prettyName: 'Diameter',
        validators: [validators.isNumber(), validators.notNull()],
      },
      defaultDevice: {
        prettyName: 'Default Device',
        validators: [validators.isBoolean(), validators.notNull()],
      },
    };

    return Object.freeze({
      get id() { return id },
      get companyId() { return companyId },
      get name() { return name },
      get diameter() { return diameter },
      get defaultDevice() { return defaultDevice },
      get flowDeviceKFactors() { return flowDeviceKFactors?.map(fdkf => makeFlowDeviceKFactor(fdkf)) ?? []; },
      get createdBy() { return createdBy },
      get createdDate() { return createdDate ? new Date(createdDate) : null },
      get modifiedBy() { return modifiedBy },
      get modifiedDate() { return modifiedDate ? new Date(modifiedDate) : null },
      get deletedBy() { return deletedBy },
      get deletedDate() { return deletedDate ? new Date(deletedDate) : null },
      validate() {
        const errors = validate(this, schema);
        if (errors.length > 0) {
          const message = errors.map(e => e.name + ': ' + e.message).join('\n');
          const validationError = new Error(message);
          validationError.name = 'ValidationError';
          throw validationError;
        }
      }
    });
  }
}